var FileData_PDFSettings_ViewMode = /* @__PURE__ */ ((FileData_PDFSettings_ViewMode2) => {
  FileData_PDFSettings_ViewMode2["NONE"] = "NONE";
  FileData_PDFSettings_ViewMode2["FULL"] = "FULL";
  FileData_PDFSettings_ViewMode2["MINI"] = "MINI";
  FileData_PDFSettings_ViewMode2["UNRECOGNIZED"] = "UNRECOGNIZED";
  return FileData_PDFSettings_ViewMode2;
})(FileData_PDFSettings_ViewMode || {});
export {
  FileData_PDFSettings_ViewMode
};
//# sourceMappingURL=plugin_file.enums.js.map
